import {  Button, TextFieldEditor, Spinner } from '../../components';
import { useState } from 'react';
import s from './Login.module.scss';

export const LoginForm = ({ login, ssoLogin, forgotPassword }) => {
    const [email, setEmail] = useState(''); 
    const [password, setPassword] = useState(''); 
    const [buttonSpinner, setButtonSpinner] = useState(null);
    const buttonDisabled = !(email && password);
    const renderSpinner = (label, color) => (buttonSpinner === label ? <Spinner data-testid={label} loading={true} small color={color} /> : label);

    return <div className={s.loginForm} data-testid="login-form-container">
            <form className={s.formBox} onSubmit={(e) => {
                setButtonSpinner("Login");
                login({ email, password, e });
            }}>
                <TextFieldEditor firstLetterUppercase={true} big={true} label="email" value={email} onChange={setEmail} />
                <TextFieldEditor firstLetterUppercase={true} big={true} password={true} label="password" value={password} onChange={setPassword} />

                <Button disabled={buttonDisabled} className={s.primaryBtn} label={renderSpinner("Login")} />
            </form>
            <Button className={s.ssoBtn} label={renderSpinner("Sign in with SSO", "#2b2b2b")} onClick={() => {
                setButtonSpinner("Sign in with SSO");
                ssoLogin();
            }}/>
            <button type="button" className={s.forgotPassword} data-testid="Forgot password?-button"  onClick={forgotPassword} >Forgot password?</button>
        </div>
}